// @core/api/endpoints/fiscalization/deregister_fiscal_point.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  DeregisterFiscalPointRequest,
} from '../../../types/fiscalization';

const BASE_PATH = '/fiscalization';

/**
 * Deregister fiscal point
 * Deregisters a fiscal point. Requires all shifts to be closed and no pending receipts.
 */
export async function DeregisterFiscalPoint(
  id: string,
  data: DeregisterFiscalPointRequest,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/fiscal-points/:id/deregister`;
  requestPath = requestPath.replace(':id', encodeURIComponent(id));
  const requestOptions = options;
  return client.post<Response>(requestPath, data, requestOptions);
}
